export default __webpack_public_path__ + "static/media/laligalandLogo.49e384e6.svg";